var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgThumbDown = function SvgThumbDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#52525B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.334 9.22v1.197a2.083 2.083 0 1 0 4.166 0v-5a2.083 2.083 0 1 0-4.166 0V6.89m0 2.33c-.002.678-.013 1.07-.083 1.452-.074.399-.196.788-.364 1.157-.189.417-.455.8-.988 1.565l-2.51 3.605a2.218 2.218 0 0 1-.125.171.833.833 0 0 1-1.151.102c-.035-.028-.075-.067-.153-.146a5.667 5.667 0 0 1-.263-.272 2.5 2.5 0 0 1-.501-2.37c.026-.086.06-.176.13-.355l.04-.104c.111-.288.167-.433.188-.547a1.25 1.25 0 0 0-.999-1.457c-.114-.02-.268-.02-.578-.02H3.988c-.8 0-1.2 0-1.487-.163a1.25 1.25 0 0 1-.55-.639c-.118-.308-.059-.703.06-1.495l.443-2.962c.18-1.21.27-1.814.565-2.268a2.5 2.5 0 0 1 1.064-.916c.493-.224 1.104-.224 2.327-.224h2.924c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093c.242.475.27 1.08.273 2.191m0 2.33V6.89"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThumbDown);
export default ForwardRef;